__turbopack_context__.v({
  "Container": "owv9Ba_Container",
  "Content": "owv9Ba_Content",
  "CustomContent": "owv9Ba_CustomContent",
  "Description": "owv9Ba_Description",
  "DescriptionText": "owv9Ba_DescriptionText",
  "Root": "owv9Ba_Root",
  "Text": "owv9Ba_Text",
  "TextContent": "owv9Ba_TextContent",
  "TextWrapper": "owv9Ba_TextWrapper",
  "Title": "owv9Ba_Title",
  "skeleton-loading": "owv9Ba_skeleton-loading",
});
